window.addEventListener('DOMContentLoaded', () => {
    window.onload = () => {
        window.requestAnimationFrame(() => {
            // Had to convert this for IE 11
            const event = document.createEvent('Event')
            event.initEvent('frame-ready', true, true)
            window.dispatchEvent(event)
        })
    }
})
